const STORAGE_KEY_GUEST_SOCIETY_PREFERENCE = 'guest_society_preference_v1';

const isValidId = (value) => Number.isInteger(value) && value > 0;

const normalizePreference = (input) => {
  if (!input || typeof input !== 'object') return null;

  const id = Number(input.id);
  const slug = typeof input.slug === 'string' ? input.slug.trim() : '';
  const name = typeof input.name === 'string' ? input.name.trim() : '';
  const city = typeof input.city === 'string' ? input.city.trim() : '';

  if (!isValidId(id)) return null;
  if (!slug && !name) return null;

  return {
    id,
    slug,
    name,
    city,
    updatedAt: Date.now(),
  };
};

export const getGuestSocietyPreference = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_GUEST_SOCIETY_PREFERENCE);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const normalized = normalizePreference(parsed);
    if (!normalized) {
      localStorage.removeItem(STORAGE_KEY_GUEST_SOCIETY_PREFERENCE);
      return null;
    }
    return normalized;
  } catch (_) {
    return null;
  }
};

export const setGuestSocietyPreference = (society) => {
  const normalized = normalizePreference(society);
  if (!normalized) return null;

  try {
    localStorage.setItem(STORAGE_KEY_GUEST_SOCIETY_PREFERENCE, JSON.stringify(normalized));
    return normalized;
  } catch (_) {
    return null;
  }
};

export const clearGuestSocietyPreference = () => {
  try {
    localStorage.removeItem(STORAGE_KEY_GUEST_SOCIETY_PREFERENCE);
  } catch (_) {}
};

export { STORAGE_KEY_GUEST_SOCIETY_PREFERENCE };
